<template>
 <div :class="windowClass">
        <v-row no-gutters>
            <v-col md="8"
            offset-md="2"
            class="pa-1">
                    <v-expansion-panels focusable>

                    <v-expansion-panel>
                        <v-expansion-panel-header class="pa-3">
                            FISHCAR: <span class="ml-3 title va-underline">{{fishcar.name}}</span><v-spacer/>SERIES: <span class="ml-3 title va-underline">{{SEQUENCE}}</span><v-spacer/>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                           <v-row>
                                <v-col
                                    v-for="(item, i) in fishcars"
                                    :key="i + '-car'"
                                    cols="6"
                                    md="4"
                                >
                                   <v-btn block color="secondary" @click="fishcar=item, getSequence(), getSupplies()">{{item.name}}</v-btn>
                                </v-col>
                            </v-row>

                        </v-expansion-panel-content>
                    </v-expansion-panel>

                     <v-expansion-panel v-if="fishcar.id">
                        <v-expansion-panel-header expand-icon="no-icon">
                          <v-row>
                            <v-col cols="3">
                              <v-select
                              filled
                              label="Customer Type"
                             outlined
                             v-model="ctype"
                             :items="['All', 'Cash', 'Credit']"
                              >

                              </v-select>
                            </v-col>
                            <v-col cols="9">
                              <v-autocomplete
                            v-model="customer"
                            :items="FILTERED"
                            item-text="firstname"
                             :hint="`Parent: ${customer.parent_name}`"
                             persistent-hint
                            item-value="id"
                            label="Select"
                              return-object
                             filled
                             color="success"
                             outlined
                            />
                            </v-col>
                          </v-row>
                        
                           
                        </v-expansion-panel-header>
                    </v-expansion-panel>
                    <v-expansion-panel>
                        <v-expansion-panel-header>FISH: {{fish.name}}<v-spacer/>PRICE: {{$money(fish.price)}}<v-spacer/></v-expansion-panel-header>
                        <v-expansion-panel-content>
                           <template v-if="customer.id">
                           <v-row>
                                <v-col
                                    v-for="(item, i) in supplies"
                                    :key="i + '-fish'"
                                    cols="6"
                                    md="4"
                                >
                                   <v-btn block color="secondary" @click="fish=item, form=true">{{item.name}}</v-btn>
                                </v-col>
                            </v-row>
                           </template> 
                           <template v-else>
                               <v-alert
      border="top"
      dense
      class="mt-4 text-center"
      color="red lighten-2"
      dark
    >
      Please select customer!
    </v-alert>
                           </template>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>

                 <v-footer padless class="mt-10" v-if="showbtn">
                       <v-btn color="warning" rounded><v-icon left @click="Clear()">mdi-refresh</v-icon> RESET</v-btn>
                       <v-spacer/>
                        <v-btn
                        class="ma-2"
                        :loading="loading"
                        :disabled="loading"
                        color="success"
                        rounded 
                        @click="addSales()"
                        >
                       <v-icon left small>mdi-check</v-icon> CONFIRM
                        <template v-slot:loader>
                            <span>Loading...</span>
                        </template>
                        </v-btn>
                </v-footer>
            </v-col>
        </v-row>
        <va-encoder-form :show="form"  @DialogEvent="formEvent" />
        <va-encoder-confirm :show="confirm" :sales="sales" :fishcar="fishcar" :customer="customer"  @DialogEvent="cEvent" />
  </div>
</template>
<script>
import { API_MIXINS } from '@/mixins/api_mixins.js'
import {
  mapMutations
} from 'vuex'
  export default {
    mixins: [API_MIXINS],
    data: () => ({
        form: false,
        confirm: false,
        loading: false,
        search:'',
        ctype:'All',
        kind:{},
        state:'new',
        supplies:[],
        fish:{},
        fishcars:[],
        fishcar:{},
        customers:[],
        customer:{},
        selected_date: '',
        sales: {},
        showbtn: false,
    }),
    beforeCreate: function () {
      if (!this.$session.exists()) {
        this.$router.push('/')
      }
    },
    created() {
       if (this.$session.exists()) {
          this.$http.defaults.headers.common['Authorization'] = 'Bearer ' + this.$session.get('jwt')
          this.setLoggedIn(true) 
          this.selected_date = this.$moment().format('YYYY-MM-DD')
          this.getCustomers()
          this.getFishcars()
        }
    },
    computed:{
       windowClass() {
        if(this.$store.state.responsive){
          return "va-reponsive"
        } else {
          return "va-not-reponsive"
        }
      },
      FILTERED(){
        if(this.ctype=='All') {
          return this.customers
        }

        var data = this.customers.reduce((res,item)=>{
            if(this.ctype == 'Cash') {
              if(item.credit != 'enabled') {
                res.push(item)
              }
            } else {
              if(item.credit == 'enabled') {
                res.push(item)
              }
            }
            return res
        },[])
        return data
      },
      SEQUENCE() {
          return this.$store.state.sequence
      }
    },
    methods: {
      ...mapMutations(['setAlert', 'setAlertColor', 'setAlertText', 'setLoggedIn']),
      formEvent(data){
        this.form = false
        if(data.action != 'close') {
            this.getSequence()
            var payment_type = 'cash'
            this.customer.credit == 'enabled'?payment_type='credit':payment_type='cash'
            this.sales.supplier = this.fishcar.id
            this.sales.customer  = this.customer.id
            this.sales.amount  = "0" //this.total_amount.toString()
            this.sales.payment_type = payment_type
            this.sales.status = "for weighing"
            this.sales.sequence = this.SEQUENCE
            this.sales.name = this.fish.name
            this.sales.description = this.fish.description
            this.sales.supplier = this.fishcar.id
            this.sales.product = this.fish.id
            this.sales.price = data.details.price.toString()
            this.sales.container = data.details.container
            this.sales.borrowed = data.details.borrowed
            this.fish.price = data.details.price
           // this.showbtn = true
             this.confirm = true
        }
      },
      cEvent(data) {
        this.confirm=false
        if(data=='ok') {
          this.addSales()
        }
      },
      Clear(){
          this.sales = {}
          this.fishcar ={}
          this.fish ={}
          this.customer = {}
          this.supplies = []
      },
      addSales(){
          this.loading = true
          this.getSequence()
           this.sales.sequence = this.SEQUENCE
           setTimeout(()=>{
                this.$http.post("sale/new", this.sales).then(response => {
                  console.log(response.data)
                    if(response.data.status == true) {
                      
                        this.VA_ALERT('success', response.data.message)
                       this.checkinContainer(response.data.data)
                       this.Clear()
                    } else {
                        this.VA_ALERT('success', response.data.message)
                    }
                    this.showbtn = false
                    this.loading = false
                }).catch(e => {
                console.log(e.data)
                })
           }, 200)
           
      },

      checkinContainer: function(data) {
            let param = {}
              param.sales_id = data.id
              param.container_no = data.container
               param.status = "used"
              console.log(param)
               this.$http.post("container/add_borrow", JSON.stringify(param)).then(response => {
                    console.log(response.data.status)
                }).catch(e => {
                console.log(e.data)
              })
      },
      getCustomers: function() { 
          this.$http.post("customer/list", JSON.stringify({})).then(response => {
            response.data.data != null?this.customers = response.data.data:this.customers = []
           //  console.log(this.customers)
          }).catch(e => {
           console.log(e.data)
         })
     },
      getFishcars: function() {
        this.$http.post("supplier/list", JSON.stringify({method: 'today'})).then(response => {
              response.data.data != null?this.fishcars = response.data.data:this.fishcars = []
             
          }).catch(e => {
           console.log(e.data)
         })
    },
     getSupplies: function() {
         this.supplies = []
        this.$http.post("product/query_by_supplier", JSON.stringify({date: this.selected_date, supplier: this.fishcar.id})).then(response => {
                 response.data.data != null?this.supplies = response.data.data:this.supplies = []
          }).catch(e => {
           console.log(e.data)
         })
    },
    getSequence: function() {
        this.GET_SEQUENCE(this.fishcar.id)
    },
    }
  }
</script>